<div class="zas-row zas-headline-3">
    {{ division.Label }}
    <div *ngIf="division.ProductVersion" class="product-version">
        Versionsnummer: {{ division.ProductVersion }}
    </div>
</div>
<tracking-text
    [label]="productsByKey[division.ProductKey]?.riskName || 'Risiko'"
    name="risk"
    [full]="false"
    [data]="division.Risk"
    [validity]="validity"
></tracking-text>
<div *ngIf="division.Application !== 'WebLife'" class="zas-row">
    <zbd-input
        type="checkbox"
        name="viaLink"
        class="zas-main-col"
        label="Der Kunde erhält das Angebot per Link"
        appearance="touch"
        [entity]="division"
        property="ViaLink"
        [updateFn]="updateViaLink"
    ></zbd-input>
</div>
<tracking-text
    label="Kundenwunsch"
    name="description"
    [data]="division.Decision.Description"
    [validity]="validity.decision"
    target="decision"
    [division]="division"
></tracking-text>
<tracking-text
    label="Begründung"
    name="reason"
    [show-additional]="false"
    [data]="division.Decision.Reason"
    [validity]="validity.decision"
    target="decisionReason"
    [division]="division"
></tracking-text>
<div class="zas-row"></div>
<div *ngIf="division.Application !== 'WebLife'" class="zas-row">
    <zbd-input
        type="checkbox"
        name="asRecommended"
        class="zas-main-col"
        label="Das Angebot stimmt mit der Empfehlung überein"
        appearance="touch"
        [entity]="division.Decision"
        property="IsDecisionSameAsRecommendation"
        [updateFn]="persistence.updateDecision"
    ></zbd-input>
</div>
<div *ngIf="!division.Decision.IsDecisionSameAsRecommendation" class="zas-row">
    <div class="zas-main-col gutter-container">
        <zbd-input
            type="textarea"
            name="asRecommendedReason"
            class="gutter-main"
            rows="5"
            [entity]="division.Decision"
            property="AsRecommendedReason"
            [updateFn]="persistence.updateDecision"
            [validity]="validity.decision"
            [securityFilter]="'light'"
        ></zbd-input>
        <div class="gutter-side">
            <zbd-info
                >Ist die Angebotserstellung abweichend von Ihrer Empfehlung, so
                ist diese Abweichung verpflichtend zu begründen. Stimmt das
                Angebot mit Ihrer Empfehlung überein, so markieren Sie bitte
                „Das Angebot stimmt mit der Empfehlung überein“. In diesem Fall
                ist eine Begründung optional.</zbd-info
            >
        </div>
    </div>
</div>
<ng-container *ngIf="division.Application !== 'WebLife'">
    <div class="zas-row zas-headline-3">Kundenentscheidung</div>
    <div class="zas-row">
        <zbd-input
            type="radio"
            name="isAccepted"
            class="zas-main-col"
            label="Der Kunde nimmt das Angebot an"
            [value]="true"
            appearance="touch"
            [entity]="division.Decision"
            property="IsAccepted"
            [updateFn]="updateIsAccepted"
        ></zbd-input>
        <zbd-input
            type="radio"
            name="isAccepted"
            class="zas-main-col"
            label="Der Kunde lehnt das Angebot ab"
            [value]="false"
            appearance="touch"
            [entity]="division.Decision"
            property="IsAccepted"
            [updateFn]="updateIsAccepted"
        ></zbd-input>
    </div>
    <div *ngIf="division.Decision.IsAccepted === false" class="zas-row">
        <zbd-input
            type="textarea"
            name="rejectReason"
            class="zas-main-col"
            rows="5"
            label="Begründung der Ablehnung"
            [entity]="division.Decision"
            property="RejectReason"
            [updateFn]="persistence.updateDecision"
            [securityFilter]="'light'"
        ></zbd-input>
    </div>
</ng-container>
